import { render } from "./CompanyTab.vue?vue&type=template&id=8b631378&scoped=true"
import script from "./CompanyTab.vue?vue&type=script&lang=js"
export * from "./CompanyTab.vue?vue&type=script&lang=js"

import "./CompanyTab.vue?vue&type=style&index=0&id=8b631378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b631378"]])

export default __exports__